var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroModalImagePlaceholderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.482,
    height: 55.482,
    viewBox: "0 0 55.482 55.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(-233 -290)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M43.923,0H11.559A11.573,11.573,0,0,0,0,11.559V43.923A11.573,11.573,0,0,0,11.559,55.482H43.923A11.573,11.573,0,0,0,55.482,43.923V11.559A11.573,11.573,0,0,0,43.923,0ZM11.559,4.623H43.923a6.935,6.935,0,0,1,6.935,6.935V43.923a6.822,6.822,0,0,1-.694,2.971L28.982,25.711a11.559,11.559,0,0,0-16.349,0l-8.01,8.008V11.559A6.935,6.935,0,0,1,11.559,4.623Zm0,46.235a6.935,6.935,0,0,1-6.935-6.935V40.257L15.9,28.98a6.935,6.935,0,0,1,9.811,0L46.894,50.165a6.822,6.822,0,0,1-2.971.694Z",
    transform: "translate(233 290)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M20.591,19.682A8.091,8.091,0,1,0,12.5,11.591a8.091,8.091,0,0,0,8.091,8.091Zm0-11.559a3.468,3.468,0,1,1-3.468,3.468,3.468,3.468,0,0,1,3.468-3.468Z",
    transform: "translate(249.397 294.591)",
    fill: "#d9d9d9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroModalImagePlaceholderIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroModalImagePlaceholderIcon.f79dee9551b2b62b4b3d561d82d93dae.svg";
export { ForwardRef as ReactComponent };